export default "__VITE_ASSET__cc6a0429__"